import React from 'react';

import KeyboardOptionList from 'views/playground/features/data-lab/components/keyboard-option-list';

export type SiteFilterOption = { id: string; label: string };

type Props = {
  options: SiteFilterOption[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
};

// Provides keyboard access to the same site filter as the chart marks.
const SiteFilterList: React.FC<Props> = ({ options, selectedId, onSelect }) => {
  return (
    <KeyboardOptionList
      options={options}
      selectedId={selectedId}
      onSelect={onSelect}
      ariaLabel="Filter by site"
    />
  );
};

export default SiteFilterList;
